<template>
  <section class="card_style">
    <supliersSkelton v-if="loading" />
    <form @submit.prevent="editsupplier()" v-else>
      <div class="main_header_style flex-column">
        <h4>{{ $t("edit_suppliers") }}</h4>
      </div>
      <div class="row">
        <!-- room name ar -->
        <div class="col-lg-4 mb-4">
          <label for="name">{{ $t("name") }}</label>
          <input
            type="text"
            :placeholder="$t('room name')"
            id="name"
            v-model="name"
          />
        </div>

        <!-- room name en -->
        <div class="col-lg-4 mb-4">
          <label for="email">{{ $t("email") }}</label>
          <input
            type="email"
            :placeholder="$t('email')"
            id="email"
            v-model="email"
          />
        </div>

        <div class="col-lg-4 mb-4">
          <label for="phone">{{ $t("phone") }}</label>
          <input type="number" :placeholder="$t('phone')" v-model="phone" />
        </div>

        <div class="col-lg-4 mb-4">
          <label for="adult">{{ $t("address") }}</label>
          <input type="text" :placeholder="$t('address')" v-model="address" />
        </div>

        <div class="col-lg-4 mb-4">
          <label for="adult">{{ $t("country") }}</label>
          <Multiselect
            v-model="countryValues"
            track-by="id"
            label="title"
            :options="countries"
            :clear-on-select="true"
            :placeholder="$t('choose_country')"
            select-label=""
            :hide-selected="true"
          >
          </Multiselect>
        </div>

        <div class="col-lg-4 mb-2">
          <label for="type" class="fw-bold"
            >{{ $t("Manual code") }}

            <sub class="info">
              <b>( {{ $t("unique code for suplier") }} )</b>
            </sub>
          </label>
          <input
            class="form-control"
            type="text"
            :placeholder="$t('Manual code')"
            v-model="manual_code"
          />
        </div>

        <div class="col-lg-4 mb-4">
          <label for="type">{{ $t("supplier_type") }}</label>
          <Multiselect
            v-model="supplier_type_value"
            :options="supplier_types"
            label="title"
            track-by="id"
            :clear-on-select="true"
            :placeholder="$t('choose_supplier_type')"
            select-label=""
            :hide-selected="true"
          >
          </Multiselect>
          <!-- <span class="input-errors" v-if="v$.supplier_type_value.$error"
            >{{ v$.supplier_type_value.$errors[0].$message }}
          </span> -->
        </div>
        <div class="col-lg-4 mb-4">
          <label for="tax">{{ $t("tax number") }}</label>
          <input
            type="text"
            :placeholder="$t('tax number')"
            v-model="tax_number"
          />
        </div>

        <div class="col-lg-4 mb-4">
          <label for="Registration">{{ $t("Registration number") }}</label>
          <input
            type="text"
            :placeholder="$t('Registration number')"
            v-model="registration_number"
          />
        </div>

        <div class="col-12 my-2">
          <div class="d-flex align-items-center gap-2">
            <Checkbox v-model="checked" :binary="true" />
            <p class="mb-0">{{ $t("can deal with as client") }}</p>
          </div>
        </div>

        <div class="col-lg-12 mb-4">
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="cash"
                v-model="payment_method"
                value="1"
              />
              <label class="form-check-label" for="cash">
                {{ $t("cash") }}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="pending"
                v-model="payment_method"
                value="2"
              />
              <label class="form-check-label" for="pending">
                {{ $t("pending_payment") }}
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                id="prepending"
                v-model="payment_method"
                value="3"
              />
              <label class="form-check-label" for="prepending">
                {{ $t("Pre_Payment") }}
              </label>
            </div>
          </div>
        </div>

        <div class="row" v-if="payment_method == 3">
          <div class="col-lg-4 mb-4">
            <label for="adult">{{ $t("down_money") }}</label>
            <input
              type="number"
              :placeholder="$t('enter_down_money')"
              v-model="down_payment"
            />
          </div>
          <!-- start input group -->
          <div class="col-lg-4 col-12 mb-4">
            <div class="input-group">
              <label class="form-label">{{
                $t("choose_payment_method")
              }}</label>
              <Multiselect
                v-model="paidValues"
                :options="paids"
                label="title"
                track-by="id"
                :clear-on-select="true"
                :placeholder="$t('choose_payment_method')"
                select-label=""
                :hide-selected="true"
                @update:model-value="FetchAccounts(paidValues)"
              >
              </Multiselect>
            </div>
          </div>
          <!-- finish input group -->

          <div class="col-lg-4 col-12 mb-4">
            <label class="form-label">{{ $t("accounts") }}</label>
            <Multiselect
              v-model="accountValue"
              :options="accounts"
              label="text"
              track-by="id"
              :clear-on-select="true"
              :placeholder="$t('accounts')"
              select-label=""
              :hide-selected="true"
            >
            </Multiselect>
          </div>
        </div>

        <div v-if="payment_method == 2">
          <div class="col-lg-6 mb-4">
            <label for="adult">{{ $t("Credit Limit") }}</label>
            <input
              type="number"
              :placeholder="$t('Enter Credit Limit')"
              v-model="credit_limit"
            />
          </div>
        </div>

        <div class="col-lg-4 mb-4" v-if="payment_method == 1">
          <label for="account">{{ $t("account number") }}</label>
          <input
            type="text"
            :placeholder="$t('Enter account number')"
            v-model="account_number"
          />
        </div>

        <div class="col-lg-4 mb-4" v-if="payment_method == 1">
          <label for="bank">{{ $t("bank name") }}</label>
          <input
            type="text"
            :placeholder="$t('bank name')"
            v-model="bank_name"
          />
        </div>

        <div class="col-lg-4 mb-4" v-if="payment_method == 1">
          <label for="IBAN">{{ $t("IBAN") }}</label>
          <input type="text" :placeholder="$t('IBAN')" v-model="IBAN" />
        </div>
      </div>

      <button type="submit" class="add save btn">{{ $t("add") }}</button>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import supliersSkelton from "@/components/skelton/supliersSkelton.vue";
import Checkbox from "primevue/checkbox";
export default {
  name: "add-suppliers",
  data() {
    return {
      checked: false,
      loading: true,
      name: "",
      manual_code: "",
      email: "",
      phone: "",
      address: "",
      countryValues: "",
      countries: [],
      credit_limit: "",
      down_payment: "",
      payment_method: 1,
      tax_number: "",
      registration_number: "",
      supplier_types: [],
      supplier_type_value: {},
      paids: [
        {
          id: 1,
          title: this.$t("treasury"),
        },
        {
          id: 2,
          title: this.$t("bank"),
        },
        {
          id: 3,
          title: this.$t("ewalllets"),
        },
        {
          id: 4,
          title: this.$t("checks_under_collection"),
        },
      ],
      accountValue: "",
      paidValues: "",
      accounts: [],
      account_number: "",
      bank_name: "",
      IBAN: "",
    };
  },
  components: {
    Multiselect,
    supliersSkelton,
    Checkbox,
  },
  methods: {
    //fetch country
    fetch_country() {
      axios.post("/fetch_countries").then(({ data }) => {
        this.countries = data.data.map((ele) => {
          ele.title = `${ele.title} - ${ele.code} (${ele.id})`;
          return ele;
        });
      });
    },

    fetchSuppliersData() {
      let id = this.$route.params.id;
      axios.get("/consumers/" + id).then(({ data }) => {
        // console.log(data);
        this.name = data.data.name;
        this.email = data.data.email;
        this.phone = data.data.phone;
        this.address = data.data.address;
        this.countryValues = {
          id: data.data.country.id,
          code: data.data.country.code,
          title: `${data.data.country.title} - ${data.data.country.code} (${data.data.country.id})`,
        };
        this.down_payment = data.data.down_payment;

        this.registration_number = data.data.registration_number;
        this.tax_number = data.data.tax_number;

        this.payment_method = data.data.payment_method;
        if (data.data.payment_method == 3) {
          this.accountValue = data.data.tree_branch;
          this.payment_method = data.data.payment_method;

          this.paids.forEach((ele) => {
            if (ele.id == data.data.payment_method_type) {
              this.paidValues = ele;
            }
          });
        }
        if (data.data.payment_method == 2) {
          this.credit_limit = data.data.credit_limit;
        }
        this.account_number = data.data.bank_account_number;
        this.bank_name = data.data.bank_name;
        this.IBAN = data.data.Iban;
        this.supplier_type_value = data.data.supplier_type;
        this.manual_code = data.data.manual_code;
        this.checked = data.data.is_client == 1 ? true : false;
        this.loading = false;
      });
    },
    // add revenue
    async editsupplier() {
      let id = this.$route.params.id;
      const params = new URLSearchParams();
      params.append("manual_code", this.manual_code);
      params.append("is_client", this.checked ? 1 : 0);
      params.append("name", this.name);
      params.append("email", this.email);
      params.append("phone", this.phone);
      params.append("address", this.address);
      params.append("country_id", this.countryValues.id);
      params.append("role", 2);
      params.append("registration_number", this.registration_number);
      params.append("tax_number", this.tax_number);
      params.append("supplier_type_id", this.supplier_type_value.id);
      params.append(`payment_method`, this.payment_method);

      if (this.payment_method == 1) {
        params.append("bank_name", this.bank_name);
        params.append("Iban", this.IBAN);
        params.append("bank_account_number", this.account_number);
      } else if (this.payment_method == 2) {
        params.append("Pending_limit", this.credit_limit);
        params.append("credit_limit", this.credit_limit);
      } else if (this.payment_method == 3) {
        params.append("prepayment_amount", this.down_payment);
        params.append("down_payment", this.down_payment);
        params.append(`payment_method_type`, this.paidValues?.id);
        if (this.accountValue) {
          params.append(`safe_branch_id`, this.accountValue.id);
        }
      }

      axios
        .put(`/consumers/${id}`, params)
        .then((response) => {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "success",
          });
          this.$router.push("/suppliers");
        })
        .catch((error) => {
          Swal.fire({
            title: "",
            text: error.response.data.message,
            icon: "error",
          });
        });
    },
    FetchAccounts(account_id) {
      let type = { payment_method: account_id?.id };
      axios.post(`/fetch_payment_method`, type).then(({ data }) => {
        this.accounts = data.data;
      });
    },
    fetch_supplier_types() {
      axios.get("/supplier_types").then(({ data }) => {
        this.supplier_types = data.data.data;
      });
    },
  },
  created() {
    this.fetch_country();
    this.fetchSuppliersData();
    this.fetch_supplier_types();
  },
};
</script>

<style lang="scss" scoped>
@import "./_suppliers";
form {
  label {
    display: inline-block;
    margin-bottom: 10px;
    font-family: "bold" !important;
  }
  input,
  select {
    display: block;
    width: 100%;
    // height: 68px;
    border-radius: 4px;
    border: 1px solid #9ca2ac;
    color: #9ca2ac;
    padding: 10px 15px;
  }
}
.form-check-inline {
  display: inline-flex;
  flex-direction: column;
  margin-top: 0;
}
.form-check-input {
  width: 17px;
  height: 17px;
  padding: 0;
}
.info {
  font-size: 0.7rem;
}
</style>
